module.exports = __webpack_public_path__ + "media/Images/plan-401k-header-image-advisor-0d22430f6561dcdad04a754fa5805e92.jpg";